/* eslint-disable react/no-unescaped-entities */
import React, { useContext } from 'react';
import './HomeText.scss';
import getText from '../../assets/locale/locale';
import { LocaleContext } from '../../contexts';
import logo from '../../assets/sp_logo.svg';

const HomeText = () => {
  const locId = useContext(LocaleContext);

  return (
    <div className="homepage">
      <div className="maintext">
        <div className="upper">
          <div aria-hidden className="logoimg">
            <img src={logo} alt="Logo" />
          </div>
          <h1>{getText(locId, 'PersonalInfo', 'heading', 'HomeText')}</h1>
        </div>
        <div className="lower">
          <h2>{getText(locId, 'PersonalInfo', 'headingTwo', 'HomeText')}</h2>
          <p>
            {getText(locId, 'PersonalInfo', 'paragraphOnePart1', 'HomeText')}
            <a
              href={getText(locId, 'PersonalInfo', 'linkUrl', 'HomeText')}
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              {getText(locId, 'PersonalInfo', 'linkText', 'HomeText')}
            </a>
            {getText(locId, 'PersonalInfo', 'paragraphOnePart2', 'HomeText')}
          </p>
          <p>{getText(locId, 'PersonalInfo', 'paragraphTwo', 'HomeText')}</p>
        </div>
      </div>
    </div>
  );
};

export default HomeText;
